import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalConfirmation({ game, quantity, totalKr, onConfirm, onCancel }) {
  const { t } = useTranslation();

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>Bekreft salg av skrapelodd</h1>
            <p style={{ fontSize: '22px', marginTop: '20px' }}>
              <strong style={{ color: '#42a5f5' }}>{quantity}</strong> x{' '}
              <strong style={{ color: '#42a5f5' }}>{game.title}</strong> (
              {game.priceMinor / 100} kr) ={' '}
              <strong style={{ color: '#42a5f5' }}>{totalKr} kr</strong>
            </p>
            <p style={{ fontSize: '18px', marginTop: '10px' }}>
              Loddene skrives ut med QR-kode.
            </p>

            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              <button
                className="btn-custom-yes"
                onClick={onConfirm}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                {t('sales.confirm')}
              </button>
              <button
                className="btn-custom-no"
                onClick={onCancel}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <CancelIcon style={{ fontSize: '1.2em' }} />
                {t('sales.cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalConfirmation;
